export const links = {
  payNow: '/cittadini/cie/public/spontanei',
  header: 'https://www.interno.gov.it/',
  public: 'https://www.cartaidentita.interno.gov.it/',
  guide:
    'https://www.cartaidentita.interno.gov.it/richiedi/rilascio-e-rinnovo-in-italia/'
};
